"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidEmail = isValidEmail;
exports.sanitizeEmail = sanitizeEmail;
exports.validateLeadImportRow = validateLeadImportRow;
exports.isValidSlug = isValidSlug;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
function isValidEmail(email) {
    return EMAIL_REGEX.test(email.trim());
}
function sanitizeEmail(email) {
    return email.toLowerCase().trim();
}
function validateLeadImportRow(row) {
    const email = typeof row.email === 'string' ? sanitizeEmail(row.email) : null;
    if (!email || !isValidEmail(email)) {
        return null;
    }
    return {
        email,
        firstName: typeof row.first_name === 'string' ? row.first_name.trim() : undefined,
        lastName: typeof row.last_name === 'string' ? row.last_name.trim() : undefined,
        company: typeof row.company === 'string' ? row.company.trim() : undefined,
        roleTitle: typeof row.role_title === 'string'
            ? row.role_title.trim()
            : typeof row.role === 'string'
                ? row.role.trim()
                : undefined,
        country: typeof row.country === 'string' ? row.country.trim() : undefined,
        notes: typeof row.notes === 'string' ? row.notes.trim() : undefined,
    };
}
function isValidSlug(slug) {
    return /^[a-z0-9-]+$/.test(slug) && slug.length >= 3 && slug.length <= 50;
}
//# sourceMappingURL=validators.js.map